<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="the-bus-leaving-the-farm">
<h1>The Bus: Leaving the Farm</h1>
<p>The twins could still hear the mumbling and chuntering.</p>
<p>In thoughts, one twin said to her sister, <em>‘How long do you think it will take for one of them to speak up?’</em></p>
<p><em>‘It’ll be a little while yet I’m guessing,’ said her twin.</em></p>
<p><em>‘I wonder what it is that’s bothering them.’</em></p>
<p><em>‘Do you think we should ask them?’</em></p>
<p><em>‘Nah!’ laughed her twin.</em></p>
<p>They drove on for a short time, then Alinna parked the bus announcing that they should all get some air. They all clambered stretching their legs, congregated under the shade of the bus. They opened some tins of beans and ate them with the cutlery that Rosie had thought to pack.</p>
<p>It was a lovely day and once they had eaten, the children started to run around playing with the dogs.</p>
<p>One twin kept look out and the other rested against the front wheel of the bus.</p>
<p>While the others were chatting, one twin telepathically said to the other, <em>‘Shall we race to the city or just go slowly?’</em></p>
<p><em>‘I think the city will be in ruins, so I think we should go quickly and get it over with,’ said her sister speaking in turns as always.</em></p>
<p><em>‘They are going to be devastated when it’s in ruins.’</em></p>
<p><em>‘Yes I know, but there’s no point in prolonging the agony.’</em></p>
<p><em>‘Agreed, we will go straight there then, now.’</em></p>
<p><em>‘Agreed.’</em></p>
<p>Out loud one twin said to the whole group, ‘Ok everyone we are going to miss out the villages and head straight to the city.’</p>
<p>‘So, as soon as you are ready we will get going,’ said her sister.</p>
<p>There was lots of muttering and hushed speaking going on and no one had got on the bus.</p>
<p>Sensing a bit of unrest one twin said out loud, ‘So, who is still doing their exercises?’</p>
<p>‘Oh, er, I kinda forgot about that,’ said Rosie.</p>
<p>‘I am,’ said Chip, ‘I’ve been round the boundary twice every day with the dogs.’</p>
<p>‘I am,’ said George, ‘I’ve pretty much been with Chip every time.’</p>
<p>‘I’ve walked about a bit,’ said Daniel looking at his broken leg.</p>
<p>‘Right, ok, here’s what we will do,’ said one twin.</p>
<p>‘We will split into two groups, the “fit”, and the “not so fit”,’ said her sister speaking in turns as always.</p>
<p>‘The fit group will be, one of us along with Chip, George and the dogs.’</p>
<p>‘The not so fit group will be one of us, Daniel, Rosie and the children.’</p>
<p>‘One group will ride in the bus while the other walks and then we swap over.’</p>
<p>‘We know that this will slow us up a lot, but quite frankly we don’t think there is much point in rushing.’</p>
<p>‘What do you all think?’</p>
<p>There was a bit of mumbling, then chip said, ‘Count me in, it’ll be better for the dogs.’</p>
<p>‘Count me in too,’ said George, ‘it’ll be better in the fresh air.’</p>
<p>‘Great,’ said one twin, ‘we have the fit group.’</p>
<p>‘We think 3 miles to start off and then we’ll see how we get on,’ said one twin.</p>
<p>‘Ok,’ said Rosie, ‘what distance do you think for the rest of us?’</p>
<p>‘Let’s do ½ a mile to start with. How does that sound?’</p>
<p>‘Yes, ok,’ said Daniel.</p>
<p>Alinna told the ‘fit,’ group to start walking and the ‘not so fits,’ to get back on the bus.</p>
<p>‘Here we go,’ said the twin in the driving seat, I’m setting the mile counter to zero. I’ll drive for 3 miles exactly then I’ll stop the bus and wait for you guys. Is that ok?</p>
<p>‘Yup,’ came the reply.</p>
<p>One twin started to walk with Chip, George and the dogs and her twin drove off in the bus. When she reached 3 miles, she parked the bus and they all climbed out of the bus to wait for the others.</p>
<p>Eventually the fit-group appeared and they walked right up and touched the bus, to prove that their challenge was complete.</p>
<p>The twin who had been driving the bus said to Daniel and Rosie that they should start walking now and that the bus would stay behind them.</p>
<p>‘Why,’ asked Rosie.</p>
<p>‘Just in case it’s too much for Daniel or one of the children. We don’t want to push them too much too soon,’ said the twin. She hadn’t included Rosie in her reply as she wanted Rosie to feel like she could do it easily, even if she couldn’t.</p>
<p>‘Oh yes I see,’ said Rosie, happily feeling like she was only in the not so fit group to help Daniel and the children. Not because she wasn’t fit.</p>
<p>The not so fit group started walking.</p>
<p>The fit group were doing stretches and wandering around cooling down. They took a long time before they got back on the bus.</p>
<p>When they got back on the bus and set off, the not so fits had nearly covered their ½ mile.</p>
<p>Daniel waved the bus down, ‘I can’t do any more, it hurts so much.’</p>
<p>Rosie added, ‘I think the children have had enough too,’ but what she meant was that she had had enough too.</p>
<p>Alinna stopped the bus and the not so fits climbed on and sat down with a “phew!”</p>
<p>‘Well done everyone, that was brilliant,’ said the twin who wasn’t driving, ‘we will do it all again tomorrow.’</p>
<p>The fit-group shouted, “Yay!” with genuine enthusiasm. The not-so-fits said nothing at all.</p>
<p>Telepathically, one twin said to the other<em>, ‘Oh dear, Rosie doesn’t look too happy.’</em></p>
<p><em>‘Well it’s good for her,’ replied her sister in thoughts.</em></p>
<p><em>‘Agreed?’</em></p>
<p><em>‘Agreed.’</em></p>
<p>Chip shouted out, ‘Hey Alinna what kind of exercise do lazy people do?’</p>
<p>Everyone looked blank.</p>
<p>Laughing, Chip shouted out, ‘Diddly squats.’</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch024.vue?371fccfc